// prop-types is a library for typechecking of props
//import PropTypes from "prop-types";

// @mui material components
import Link from "@mui/material/Link";

// Soft UI Dashboard React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";

// Soft UI Dashboard React base styles
import typography from "assets/theme/base/typography";

// Custom styles for the Footer
import styles from "common/Footer/styles";

function Footer() {
  const { size } = typography;
  const classes = styles();

  return (
    <SuiBox
      width="100%"
      display="flex"
      flexDirection={{ xs: "column", lg: "row" }}
      justifyContent="space-between"
      alignItems="center"
      px={1.5}
    >
      <SuiBox
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexWrap="wrap"
        color="text"
        fontSize={size.sm}
        px={1.5}
      >
        &copy;
        <Link href="https://darincon.com/" target="_blank">
          <SuiTypography variant="button" fontWeight="medium">
            &nbsp;QuiralTech&nbsp;
          </SuiTypography>
        </Link>
        Coded By OurTeam.
      </SuiBox>
      <SuiBox component="ul" customClass={classes.footer_list}>
        <SuiBox key="Drincon7" component="li" px={2}>
          <Link href="#" target="_blank">
            <SuiTypography variant="button" fontWeight="regular" textColor="text">
              Support
            </SuiTypography>
          </Link>
        </SuiBox>
      </SuiBox>
    </SuiBox>
  );
}

export default Footer;
